import { 
  getTenant,
  createTenantBranch
} from '../../admin/tenant';
import { Create_Update_BranchPayload as Create_Update_TenantBranchPayload} from '../../../../contract/dtos/request';
import { TenantQueryParams } from '../../../../contract/dtos';
export const tenantQueries = {
  queries: {
    tenants: (params?: TenantQueryParams) => ({
      queryKey: ['admin', 'tenants', ...(params ? [params] : [])],
      queryFn: async () => {
        return getTenant(params);
      }
    }),
   
  },
  mutations: {
    createTenantBranch: (tenantId: number, componentId: number) => ({
      mutationKey: ['admin', 'tenant', 'update-branch', tenantId, componentId],
      mutationFn: async (data: Create_Update_TenantBranchPayload) => {
        return createTenantBranch(tenantId, componentId, data);
      }
    })
  }
};
